module.exports = __webpack_public_path__ + "static/media/kuehne.93cb4a0a.png";